import { render, staticRenderFns } from "./AmendedReportRow.vue?vue&type=template&id=5a08fd35&scoped=true&"
import script from "./AmendedReportRow.vue?vue&type=script&lang=js&"
export * from "./AmendedReportRow.vue?vue&type=script&lang=js&"
import style0 from "./AmendedReportRow.vue?vue&type=style&index=0&id=5a08fd35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08fd35",
  null
  
)

export default component.exports